export const proyectLeader = [
  {
    nombre: "Lic. Bruno Caseres",
    descripcion:
      "Licenciado en Sistemas. Ministerio de Salud de la Provincia de Jujuy",
    color: "#542141",
  },
];

export const developers = [
  {
    nombre: "José Luis Quispe",
    descripcion: "Estudiante avanzado de Ingeniería en Informática",
    color: "#542141",
  },
  {
    nombre: "Daiana Agustina Maraz",
    descripcion: "Analista Programador Universitario",
    color: "#7e7e7eff",
  },
  {
    nombre: "Maximiliano Joaquín Carrillo",
    descripcion: "Analista Programador Universitario",
    color: "#7e7e7eff",
  },
];
